export default "__VITE_ASSET__BYCWF8hX__"